import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UiSwitchModule } from 'ngx-ui-switch';
import { TableComponent } from './table.component';
import { SortModule } from './sort/sort.module';
import { TableTopComponent } from './table-top/table-top.component';
import { ButtonHideShowComponent } from './table-top/button-hide-show/button-hide-show.component';
import { EditLinkComponent } from './row-components/edit-link/edit-link.component';
import { DeleteButtonComponent } from './row-components/delete-button/delete-button.component';
import { EllipsisComponent } from './row-components/ellipsis/ellipsis.component';

import { TableFilterComponent } from './table-top/table-filter/table-filter.component';
import { ButtonResetFilterComponent } from './table-top/button-reset-filter/button-reset-filter.component';
import { ButtonFilterComponent } from './table-top/button-filter/button-filter.component';

@NgModule({
	declarations: [
		TableComponent,
		TableTopComponent,
		ButtonHideShowComponent,
		ButtonFilterComponent,
		ButtonResetFilterComponent,
		TableFilterComponent,
		// Components to be used by developers outside of table module
		EditLinkComponent,
		DeleteButtonComponent,
		EllipsisComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		CdkTableModule,
		NgbPaginationModule,
		SortModule,
		NgbTooltipModule,
		UiSwitchModule,
	],
	exports: [
		TableComponent,
		CdkTableModule,
		SortModule,
		TableFilterComponent,
		// Components to be used by developers outside of table module
		EditLinkComponent,
		DeleteButtonComponent,
		EllipsisComponent,
	],
})
export class TableModule {}
